import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../../services/user.service";
import { ICreateUser, IUpdateUser } from "../../models/user.model";

// Async thunks
export const getUsersThunk = createAsyncThunk(
  "user/getUsers",
  async (payload: { page: number; limit: number; status?: number; keyword?: string }, { rejectWithValue }) => {
    try {
      const response = await api.getUsers(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || "Get users failed");
    }
  }
);

export const createUserThunk = createAsyncThunk(
  "user/createUser",
  async (payload: ICreateUser, { rejectWithValue }) => {
    try {
      const response = await api.createUser(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || "Create user failed");
    }
  }
);

export const updateUserThunk = createAsyncThunk(
  "user/updateUser",
  async (payload: { id: string; payload: IUpdateUser }, { rejectWithValue }) => {
    try {
      const response = await api.updateUser(payload.id, payload.payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || "Update user failed");
    }
  }
);